// Func = limiting Scope for this file
var lastScrollTop = 0;


if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    }; 
}

function replaceDropDown( name, array ){
    let favorite_sport = document.querySelector( "[name="+name+"]" )
    favorite_sport.querySelectorAll( "option" ).forEach( ( item, index ) => {
        item.remove()
    } )

    array.forEach( ( item ) => {
        favorite_sport.innerHTML += "<option value="+item.replace(/ /g, '_')+">"+item+"</option>"
    } )
}

(function(){

    setTimeout( () => {
        let form_id_2690 = document.querySelector( "#form_id-2690" )
        if( form_id_2690 ){
            form_id_2690.querySelector( "#form_id-2690-yes-signup-formemail-signup" ).classList.remove( "required" )
        }
    }, 500 )

    let favorite_sport = document.querySelector( "[name=favorite_sport]" );
    if( favorite_sport ){
        $("[name=favorite_sport], [name=favorite_pro_football_team], [name=favorite_college_football_team]").attr( "data-placeholder", "Select one" );

        let sports = [
            "Select one" ,
            "None" ,
            "Soccer",
            "Basketball",
            "Baseball",
            "Football",
            "Ice Hockey",
            "Tennis",
            "Golf",
            "Cricket",
            "Rugby ",
            "Table Tennis",
            "Badminton",
            "Volleyball",
            "Wrestling",
            "Motorcross",
            "Track and Field",
            "Swimming",
            "Cycling",
            "Lacrosse",
            "Boxing",
            "MMA",
            "Karate",
            "NASCAR",
            "Wrestling (WWE)",
            "Volleyball",
            "Gymnastics",
            "Ice Skating",
            "F1",
            "Horse Racing",
            "UFC",
            "None"
        ];
        
        let nflTeams = [
            "Select one",
            "None", 
            "Arizona Cardinals", 
            "Atlanta Falcons",
            "Baltimore Ravens",
            "Buffalo Bills",
            "Carolina Panthers",
            "Chicago Bears",
            "Cincinnati Bengals",
            "Cleveland Browns",
            "Dallas Cowboys",
            "Denver Broncos",
            "Detroit Lions",
            "Green Bay Packers",
            "Houston Texans",
            "Indianapolis Colts",
            "Jacksonville Jaguars",
            "Kansas City Chiefs",
            "Las Vegas Raiders",
            "Los Angeles Chargers",
            "Los Angeles Rams",
            "Miami Dolphins",
            "Minnesota Vikings",
            "New England Patriots",
            "New Orleans Saints",
            "New York Giants",
            "New York Jets",
            "Philadelphia Eagles",
            "Pittsburgh Steelers",
            "San Francisco 49ers",
            "Seattle Seahawks",
            "Tampa Bay Buccaneers",
            "Tennessee Titans",
            "Washington Commanders"
        ];

        let collegeTeams = [
            "Select one", 
            "None",
            "Alabama Crimson Tide",
            "Appalachian State Mountaineers",
            "Arizona Wildcats",
            "Arkansas Razorbacks",
            "Auburn Tigers",
            "Baylor Bears",
            "Boston College Eagles",
            "California Golden Bears",
            "Clemson Tigers",
            "Colorado Buffaloes",
            "Connecticut Huskies",
            "Duke Blue Devils",
            "Florida Gators",
            "Florida State Seminoles",
            "Georgia Bulldogs",
            "Georgia Tech Yellow Jackets",
            "Houston Cougars",
            "Indiana Hoosiers",
            "Iowa Hawkeyes",
            "Kansas Jayhawks",
            "Kentucky Wildcats",
            "LSU Tigers",
            "Maryland Terrapins",
            "Massachusetts Minutemen",
            "Miami Hurricanes",
            "Michigan Wolverines",
            "Michigan State Spartans",
            "Minnesota Golden Gophers",
            "Missouri Tigers",
            "Nebraska Cornhuskers",
            "Nevada Wolf Pack",
            "New Mexico Lobos",
            "North Carolina Tar Heels",
            "North Dakota State Bison",
            "Northwestern Wildcats",
            "Notre Dame Fighting Irish",
            "Ohio State Buckeyes",
            "Oklahoma Sooners",
            "Oklahoma State Cowboys",
            "Ole Miss Rebels",
            "Oregon Ducks",
            "Oregon State Beavers",
            "Penn State Nittany Lions",
            "Pittsburgh Panthers",
            "Purdue Boilermakers",
            "Rutgers Scarlet Knights",
            "San Diego State Aztecs",
            "SMU Mustangs",
            "South Carolina Gamecocks",
            "Stanford Cardinal",
            "Syracuse Orange",
            "TCU Horned Frogs",
            "Tennessee Volunteers",
            "Texas Longhorns",
            "Texas A&M Aggies",
            "UAB Blazers",
            "UCF Knights",
            "USC Trojans",
            "Utah Utes",
            "Virginia Cavaliers",
            "Virginia Tech Hokies",
            "Wake Forest Demon Deacons",
            "Washington Huskies",
            "Washington State Cougars",
            "West Virginia Mountaineers",
            "Wisconsin Badgers",
            
        ];

        setTimeout( () => {

            replaceDropDown( "favorite_sport", sports )
            replaceDropDown( "favorite_pro_football_team", nflTeams )
            replaceDropDown( "favorite_college_football_team", collegeTeams )

            //$("[name=favorite_sport], [name=favorite_pro_football_team], [name=favorite_college_football_team]").chosen();
        }, 300 )
    }

    if(!(window.ActiveXObject) && "ActiveXObject" in window) {

        //is explorer
        function msieversion() {
            let ua = window.navigator.userAgent;
            let msie = ua.indexOf("MSIE ");
            if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./))
            {
                const image_fit = document.getElementsByClassName('image-fit__wrapper');
                for(let i = 0; i < image_fit.length; i++ ){
                    const this_image = image_fit[i].getElementsByTagName('img')[0];
                    const image_data = this_image.dataset.srcset;
                    const image_src = this_image.getAttribute('src');
                    image_fit[i].classList.add('ie-bg');
                    if(image_data){
                        image_fit[i].style.backgroundImage = 'url("'+image_data+'")';
                    }else{
                        image_fit[i].style.backgroundImage = 'url("'+image_src+'")';
                    }

                }
            }
            else
            {
                console.log('other browser');
            }
            return false;
        }
        msieversion();

    } else {
        /*****************************************************
         OBSERVER TO ADD PARALLAX EFFECT
         /*****************************************************/
        let scrollParallax = []
        let scrolled = 0 

        // screen height
        let v_height = window.innerHeight
            || document.documentElement.clientHeight
            || document.body.clientHeight;

        function doParallax(elm) {

            let boundes = elm.dataset.parallax.split(",") // get it from html
            //get distance in positive value
            let distance = Math.abs(boundes[0] - boundes[1])
            if (boundes[0] > boundes[1]) {
                //get distance in negative value (to do the scroll inverse)
                distance = distance * -1
            }
            //Equivalent distance using screen height + element height
            const unit_scroll = distance / (v_height + elm.offsetHeight)
            let temp = 0

            let topElement = 0;
            let element = elm;

            let id_elem = elm.dataset.parallaxid

            do {
                topElement += element.offsetTop || 0;
                element = element.offsetParent;
            } while (element)

            let parallaxFunction = function () {
                //Obtain the distance between top screen and document top 0
                scrolled = document.documentElement.scrollTop || window.pageYOffset
                //Distance of bottom page to top of the element
                let relative_distance = scrolled + v_height - topElement
                //transpoling data to move the parallax element relative to the scroll of all the screen
                temp = (unit_scroll * relative_distance) + parseInt(boundes[0])
                //console.log('scroll: '+scrolled+' v_height: '+v_height+' element top: '+elm.offsetTop)
                elm.setAttribute('style', 'transform: translate(0, ' + temp + 'px)')
            }

            scrollParallax[id_elem] = parallaxFunction

            window.addEventListener('scroll', scrollParallax[id_elem])

        }

        let observers_parallax = document.querySelectorAll(".js-parallax-element")

        if (observers_parallax) {
            let options_parallax = {
                root: null, // relative to document viewport
                rootMargin: '0px', // margin around root. Values are similar to css property. Unitless values not allowed
                threshold: 0 // visible amount of item shown in relation to root
            }

            function handler_parallax(entries, observer) {
                let entry;
                entries.forEach(function (entry) {
                    if (entry.isIntersecting) {
                        doParallax(entry.target)
                    } else {
                        let id_elem = entry.target.dataset.parallaxid
                        window.removeEventListener('scroll', scrollParallax[id_elem])
                    }
                })
            }

            let observable_parallax = new IntersectionObserver(handler_parallax, options_parallax)
            let counter = 1
            observers_parallax.forEach(function (element) {
                observable_parallax.observe(element)
                element.dataset.parallaxid = counter
                counter++
            })
        }
        /********************************************************************************
         END OF OBSERVER TO ADD PARALLAX EFFECT
         ***********************************************************************************/
    }

    let formModule = document.querySelectorAll('.form-module-wrapper form:not(#form_id-3198)');
    let textModule = document.querySelectorAll('.text-modules-wrapper .text-modules');
    if(formModule){
        formModule.forEach(function(form_module) {
            form_module.classList.add('animate-fade', 'top');
        });
    }
   if(document.querySelector('.js-booking-cta')){
        document.querySelector('.js-booking-cta').addEventListener('click', function(e){
            e.preventDefault();
            document.getElementById('bookingContainer').classList.add('open')
        });
        document.querySelector('.js-close-container').addEventListener('click', function(){
            document.getElementById('bookingContainer').classList.remove('open')
        });
   }
    let Body = document.body;

    window.onload = function() {
        scrollW();
        window.addEventListener('scroll', function(){
            scrollW();
        })
    };

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
    paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));

    $('.sym-slides').slick({
        accessibility: true
    });

    $('.slider__columns').slick({
        arrows: false,
        dots: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: false,
        autoplaySpeed: 1500,
        adaptiveHeight: true
    });

    const boxes = document.querySelectorAll('input[type=checkbox]');
    for (const box of boxes) {
        box.classList.add('required');
    }
    
    if(window.innerWidth < 1090) {

        $('.columns__list').slick({
            slidesToShow: 3,
            slidesToScroll: 1,
            dots: true,
            arrows: false,
            autoplay: true,
            autoplaySpeed: 2200,
            responsive: [
                {
                        breakpoint: 1090,
                        settings: {
                            slidesToShow: 2
                        }
                },
                {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 1
                        }
                }
            ]
        });
        // $('.hightlights__list').slick({
        //     slidesToShow: 6,
        //     slidesToScroll: 1,
        //     dots: true,
        //     responsive: [
        //         {
        //                 breakpoint: 1090,
        //                 settings: {
        //                     slidesToShow: 3
        //                 }
        //         },
        //         {
        //                 breakpoint: 768,
        //                 settings: {
        //                     slidesToShow: 1
        //                 }
        //         }
        //     ]
        // });
    }

    let ScrollDown = document.getElementsByClassName('js-scrolldown');
    if(ScrollDown.length > 0){
        ScrollDown[0].addEventListener('click', function(){
            animateto('intro');
        });
    }

    //FAQ
    let tabLabel = document.querySelectorAll('.tab-label');
    if(tabLabel){
        tabLabel.forEach(entry => {
            let thisHeightTap = entry.clientHeight;
            let thisHeight = entry.nextElementSibling.clientHeight + thisHeightTap;
            entry.parentElement.style.height = thisHeightTap+'px';
            if(entry.classList.contains('open')){
                entry.parentElement.style.height = thisHeight+'px';
            }
            entry.addEventListener('click', function(event){
                let currentclick = this;
                if(!this.classList.contains('open')){
                    tabLabel.forEach(ent => {
                        if(ent !== currentclick){
                            if(ent.classList.contains('open')){
                                ent.classList.remove('open');
                                ent.parentElement.style.height = thisHeightTap+'px';
                            }
                        }
                    });
                    this.classList.add('open');
                    this.parentElement.style.height = thisHeight+'px';
                } else {
                    this.classList.remove('open');
                    this.parentElement.style.height = thisHeightTap+'px';
                }
            });
        });
    }

    $( "a.btn" ).wrapInner( "<span></span>" );


    $('[data-fancybox]').fancybox({
        loop : true,
        backFocus: false,
        autoFocus: false,
    });

    /*MOBILE MENU NAV
	****************************************************************/

    let Html = document.getElementsByTagName('html')[0];
    let MenuBtns = document.querySelectorAll('.js-menu-btn');
    let CloseMenu = document.querySelectorAll('.close-menu');
    let Navigation = document.querySelectorAll('.navigation');
    let NavUl = document.querySelectorAll('.navigation .inner ul li');
    let NavA = document.querySelectorAll('.navigation .inner ul li a');
    let NavActive = document.querySelectorAll('.navigation ul.submenu li .active');

    //Open Navigation
    if(MenuBtns){

        MenuBtns.forEach( MenuBtn => {
            MenuBtn.addEventListener('click', function(e){
                Html.classList.add('hide-overflow');
                Navigation[0].classList.add('open');
                NavUl.forEach(function(inner) {
                    if(inner.classList.contains('item-open')){
                        inner.scrollIntoView(false);
                    }
                });
                if (MenuBtn && MenuBtn.classList.contains("js-new-link")) {
                    NavA[0].href="https://stadiumclub.reservewithrex.com/package?venue=Stadium%20Club";
                    NavA[0].classList.add('logo');
                    NavA[1].href="https://www.opentable.ca/r/stadium-club-orlando";
                    NavA[1].classList.add('logo');
                    NavA[2].href="https://stadiumclub.reservewithrex.com/package?venue=Stadium%20Club%E2%84%A0&date=2024-10-19&guests=1#WATCH%20PARTIES";
                    NavA[2].classList.add('logo');
                } else {
                    NavA[0].href="https://www.stadiumclub.com/play";
                    NavA[0].classList.remove('logo');
                    NavA[1].href="https://www.stadiumclub.com/restaurants-orlando-florida";
                    NavA[1].classList.remove('logo');
                    NavA[2].href="https://www.opentable.ca/r/stadium-club-orlando";
                    NavA[2].classList.remove('logo');
                }
         
            });
        } )
 
        // Sub-Navigation
        // Open active sub-nav on load
        NavActive.forEach(function(inner) {
            inner.closest('.inner').classList.add('open');
            inner.parentNode.parentNode.parentNode.parentNode.classList.add('item-open');
            inner.closest('.sub-sub-menu').classList.add('menu-open');
        });
 
 
 
 
        //Toggle open/close on tap
        NavA.forEach(function(entry) {
            if(entry.nextElementSibling){
                let clientHeight = entry.nextElementSibling.querySelector('.submenu').clientHeight;
                if(entry.classList.contains('active') || entry.classList.contains('parent-active')){
                    entry.nextElementSibling.classList.add('menu-open');
                    entry.nextElementSibling.style.height = clientHeight+'px';
                }
                entry.addEventListener('click', function(e){
                    e.preventDefault();
                    if(this.nextElementSibling.classList.contains('menu-open')){
                        this.nextElementSibling.classList.remove('menu-open');
                        this.nextElementSibling.style.height = '0px';
                    } else {
                        NavUl.forEach(function(ul) {
                            if(ul.querySelector('.sub-sub-menu')){
                                if(ul.querySelector('.sub-sub-menu').classList.contains('menu-open')){
                                    ul.querySelector('.sub-sub-menu').style.height = '0px';
                                    ul.querySelector('.sub-sub-menu').classList.remove('menu-open');
                                }
                            }
                        });
                        this.nextElementSibling.classList.add('menu-open');
                        this.nextElementSibling.style.height = clientHeight+'px';
                    }
                });
            }
        });
    }
 

    //Close Navigation
    if(CloseMenu[0]){
        CloseMenu[0].addEventListener('click', function(e){
            Html.classList.remove('hide-overflow');
            Navigation[0].classList.remove('open');
        });
    }

    let notCharge = document.querySelectorAll('.not-charge');
    if (notCharge){
        notCharge.forEach(entry => {
            entry.addEventListener('click', function(event){
                event.preventDefault();
            });
        });
    }

})();



function animateto(target){
    var gotoTarget = offset(document.getElementById(target)).top - 130;
    var from     = window.pageYOffset
    var to       = gotoTarget
    var duration = 1300;
    var start = new Date().getTime()

    //time interval
    var timer = setInterval(function() {
        var time = new Date().getTime() - start

        if(from <= to ){
            var y = easeInOutQuart(time, from, to - from, duration)
        } else {

            var y = easeInOutQuart(time, from, -(from - to), duration)
        }
        window.scrollTo(0, y)
        if (time >= duration) clearInterval(timer)

    }, 1000 / 60);

    window.scrollTo(0, from)

}
//ease movement
function easeInOutQuart(t, b, c, d) {
    if ((t /= d / 2) < 1) return c / 2 * t * t * t * t + b;
    return -c / 2 * ((t -= 2) * t * t * t - 2) + b;
}
function offset(el) {
    var rect = el.getBoundingClientRect(),
        scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
        scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    return { top: rect.top + scrollTop, left: rect.left + scrollLeft }
}
//ScrollW
function scrollW(){
    //check scroll down or up for header styles
    let st = window.pageYOffset || document.documentElement.scrollTop;
    let header = document.getElementById('header');
    if(st > 80){
        if (st > lastScrollTop){
            // downscroll code
            if(!header.classList.contains('down')){
                header.classList.add('down');
                header.classList.remove('up');
            }
        } else {
            // upscroll code
            if(!header.classList.contains('up')){
                header.classList.add('up');
                header.classList.remove('down');
            }
        }
    } else {
        if(header.classList.contains('up') || header.classList.contains('down')){
            header.classList.remove('up');
            header.classList.remove('down');
        }
    }

    const window_height = window.innerHeight;
	let animatedEl = document.getElementsByClassName('animate');
	for (let i = 0; i < animatedEl.length; i++) {
		var viewportOffset = animatedEl[i].getBoundingClientRect();
		let topPos = viewportOffset.top;
		if(topPos <= window_height*0.8){
			animatedEl[i].classList.add('fade-in');
		}
	}

    lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}
/*MOBILE MENU NAV
	****************************************************************/

//Open Navigation Mobile
$('#menu-btn,#booking_menu,.burger-js').click(function (event) {
	event.preventDefault();
	$('html').addClass('hide-overflow');
	$('.navigation').addClass('open');
	$('.navigation').stop().animate({ left: '0px' }, { duration: 300 });
	if ($('.navigation ul li a').hasClass('.item-open')) {
		$(".item-open").get(0).scrollIntoView(false);
	}
});

$('.close-menu').click(function (event) {
	event.preventDefault();
	$('html').removeClass('hide-overflow');
	$('.navigation').removeClass('open');
	$('.navigation').stop().animate({ left: '100%' }, { queue: false, duration: 300 });
});

document.addEventListener('DOMContentLoaded', (event) => {
    /* Open Navigation Desktop */
    let button_to_open_nav = document.querySelector('.js-menu-trigger'),
        container_navigarion = document.querySelector('#main-menu'),
        close_button_nav = document.querySelector('.js-close-menu');
    
    if( button_to_open_nav && container_navigarion ){
        button_to_open_nav.addEventListener( 'click', () => {
            container_navigarion.classList.add('open');
            document.querySelector('body').classList.add('pause-scroll');
        } );
        close_button_nav.addEventListener( 'click', () => {
            container_navigarion.classList.remove('open');
            document.querySelector('body').classList.remove('pause-scroll');
        } );
    }

    let nav_container = document.querySelector('#main-menu .privary-navigation > ul#privary-navigation'),
        beforeNodeOfNav = null;
    if ( nav_container ) {
        let all_items_of_nav = nav_container.querySelectorAll('li a');
        all_items_of_nav.forEach( each_li => {
            each_li.addEventListener( 'click', (e) => {
                if( beforeNodeOfNav && beforeNodeOfNav != each_li && each_li.nextElementSibling.nodeName == 'UL' ){
                    beforeNodeOfNav.nextElementSibling.classList.remove('clicked');
                }
                if( each_li.parentElement.parentElement.id == 'privary-navigation' && each_li.nextElementSibling.nodeName == 'UL'){
                    e.preventDefault();
                    if( each_li.nextElementSibling.classList.contains('clicked') ){
                        window.location = each_li.href;
                    }
                    each_li.nextElementSibling.classList.add('clicked');
                }
                beforeNodeOfNav = each_li;
            } );
        });
    }
});


// ANIMATE SCROLL ANCHOR ON CLICK
if (document.querySelectorAll('.js-scrollto')){
	document.querySelectorAll('.js-scrollto').forEach((btn) => {
		const btnHref = btn.getAttribute('href');
		const btnHrefArray = btnHref.split('/');
		const currentTarget = btnHref.indexOf('#') > -1 ? btnHrefArray[btnHrefArray.length - 1].replace('#', '') : false;
		if (document.getElementById(currentTarget)) {
			btn.addEventListener('click', (e) => {
				e.preventDefault();
				animateTo(currentTarget);

				// MOBILE NAV
				const mobileNav = document.querySelector('.navigation');
				if (mobileNav) {
					mobileNav.classList.remove('active');
				}
			});
		} else {
			console.warn(`Anchor "${btn.getAttribute('href')}" not found.`);
		}
	});
}

function animateTo(target) {

    var gotoTarget = offset(document.getElementById(target)).top - 120;
    var from = window.pageYOffset;
    var to = gotoTarget;
    var duration = 1200;
    var start = new Date().getTime();
    var start = null;
    
        function step(timestamp) {
            if (!start) start = timestamp;
            var progress = timestamp - start;
    
            var y = easeInOutQuart(progress, from, to - from, duration);
            window.scrollTo(0, y);
    
            if (progress < duration) {
                requestAnimationFrame(step);
            }

        }
        requestAnimationFrame(step);

    window.scrollTo(0, from);
}

//Remove required class forms 3198 & 3257

document.addEventListener('DOMContentLoaded', () => {
    if(document.querySelector("#form_id-3198-yes-signup-formemail-signup")){
        document.querySelector("#form_id-3198-yes-signup-formemail-signup").classList.remove("required");
    }

    if(document.querySelector("#form_id-3257-yes-signup-formemail-signup")){
        document.querySelector("#form_id-3257-yes-signup-formemail-signup").classList.remove("required");
    }
});

$(document).ready(function() {
    $('.fancybox').fancybox();
});

/** ADA Tab Links Functionality for Keyboard Navigation in Menu **/

function updateMenuTabIndex() {
    const menu = document.querySelector('#main-menu');
    const isMenuVisible = menu && menu.classList.contains('open');
    const elements = document.querySelectorAll('.privary-navigation__item a, .secondary-navigation__item a');
    
    elements.forEach(element => {
        element.setAttribute('tabindex', isMenuVisible ? '0' : '-1');
    });
}

document.addEventListener('DOMContentLoaded', () => {
    updateMenuTabIndex();

    document.addEventListener('focusin', updateMenuTabIndex);
    const menu = document.querySelector('#main-menu');
    if (menu) {
        menu.addEventListener('transitionend', updateMenuTabIndex);
    }
});


